<template>
  <product-section-card :title="$t('branch_detail.special_condition.title')" class="product-section-special-condition bg-red-00 <md:pb-0">
    <div v-if="specialCondition" class="mb-4 md:mb-2">
      <div ref="specialConditionRef" class="line-clamp-3">
        <bullet-text :content="specialCondition" />
      </div>
      <content-viewer
        v-if="isClamped"
        :title="$t('branch_detail.special_condition.title')"
        :is-full-height="true"
        :is-footer-shown="false"
        :is-fallback-shown="true"
        main-content-class="pt-5 pb-10"
      >
        <template #trigger="{ open }">
          <product-view-all-button @view-all-click="open" />
        </template>
        <bullet-text :content="specialCondition" />
      </content-viewer>
    </div>

    <div class="-mx-5 md:mx-0">
      <template v-for="notice in notices" :key="notice.name">
        <etg-button
          v-if="notice.show"
          icon="arrow-right"
          icon-position="right"
          iconColor="gray-60"
          size="small"
          class="px-5 py-4 justify-between border-t border-gray-40 md:px-0 md:last:border-b"
          block
          :center="false"
          @click="notice.onClick()"
        >
          {{ notice.title }}
        </etg-button>
      </template>
    </div>
  </product-section-card>
</template>

<script setup lang="ts">
import ContentViewer from '@/components/common/content-viewer.vue'
import BulletText from '@/components/common/bullet-text.vue'
import ProductMultiRulesContent from '@/components/product/product-detail/product-multi-rules-content.vue'
import ProductViewAllButton from '@/components/product/product-detail/product-view-all-button.vue'
import ProductSectionCard from '@/components/product/product-detail/product-section-card.vue'

import { useGlobalModalStore } from '@/store/global-modal'

const { t } = useI18n()

const globalModalStore = useGlobalModalStore()

const { branch } = useBranchDetailContext()

const isClamped = ref(false)
const specialConditionRef = ref<Nullable<HTMLElement>>(null)

const specialCondition = computed(() => branch.value?.special_condition)
const notices = computed(() => [
  {
    name: 'customer-notice',
    show: !!branch.value?.customer_notice,
    title: t('branch_detail.customer_notice'),
    onClick: showCustomerNoticeModal,
  },
  {
    name: 'cancel-edit-policy',
    show: !!branch.value?.reschedule_rules?.length || !!branch.value?.cancel_rules?.length,
    title: t('branch_detail.cancel_edit_policy'),
    onClick: showCancelPolicyModal,
  },
])

onMounted(() => {
  if (!specialConditionRef.value) {
    return
  }

  isClamped.value = specialConditionRef.value.scrollHeight > specialConditionRef.value.clientHeight
})

function showCustomerNoticeModal() {
  globalModalStore.showModal({
    title: t('branch_detail.customer_notice'),
    body: h(BulletText, { content: branch.value?.customer_notice }),
    isFooterShown: false,
    isFullHeight: true,
  })
}

function showCancelPolicyModal() {
  const rules = [
    {
      title: t('branch_detail.cancel_edit_policy.edit'),
      contentList: branch.value?.reschedule_rules || [],
    },
    {
      title: t('branch_detail.cancel_edit_policy.cancel'),
      contentList: branch.value?.cancel_rules || [],
    },
  ]

  globalModalStore.showModal({
    title: t('branch_detail.cancel_edit_policy'),
    body: h(ProductMultiRulesContent, { rules }),
    isFooterShown: false,
    isFullHeight: true,
  })
}
</script>
